import React from 'react';
import { inject } from 'mobx-react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Text from '../Text';

const channelsList = ({ channels, classes, expanded, currentChannel, ...props }) => {
    const wrapperClasses = classNames({
        [ classes.list ]: true,
        expanded
    });

    return (
        <div className={wrapperClasses}>
            <Text type="link" classList={[ classes.globalChannel ]}>
                <Link to={`/c/global`} className={`${classes.globalChannelAnchor} ${currentChannel !== 'global' ? 'selected' : ''}`}>Global Channel</Link>
            </Text>
            {
                channels.map((channel, i) => {
                    return (
                        <Text type="link" key={i} classList={[ classes.item ]}>
                            <Link className={classNames(
                                classes.itemAnchor,
                                {
                                    [classes.channelSelected]: currentChannel === channel.channel
                                }
                            )} to={`/c/${channel.channel}`}>{channel.channel}</Link>
                        </Text>
                    );
                })
            }
        </div>
    )
};

const styles = (theme) => ({
	list: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        background: '#f7f7f7',
        boxShadow: theme.boxShadow,
        padding: `${theme.spacing}px 0 ${theme.spacing}px ${theme.spacing}px`,
        overflowY: 'scroll',
        maxHeight: 525,

        [theme.devices.medium]: {
            maxHeight: 300,
        },

        [theme.devices.small]: {
            position: 'absolute',
            bottom: 20,
            left: -theme.spacing,
            width: '100vw',
            transform: 'translateY(100%)',
            display: 'none',
            maxHeight: 'calc(100vh - 145px)',
            paddingTop: theme.spacing * 4,
            paddingLeft: theme.spacing * 6.5,
            paddingRight: theme.spacing * 6.5,
            backgroundColor: 'rgba(0, 0, 0, 0.82)',
            zIndex: 1,

            '&.expanded': {
                display: 'flex',
            }
        },
    },
    item: {
        backgroundColor: theme.backgrounds.card,
        display: 'inline-block',
        marginBottom: theme.spacing,
        marginRight: theme.spacing,
        boxShadow: theme.boxShadow,
        flexGrow: 1,
        '&:hover': {
            backgroundColor: theme.palette.channelSelectorHover
        }
    },
    itemAnchor: {
        display: 'block',
        textAlign: 'center',
        padding: `${theme.spacing * 1.5}px ${theme.spacing * 2}px`,
        color: theme.palette.channelSelectorTypoDark,
        textDecoration: 'none',
        textTransform: 'uppercase',
        width: '100%'
    },
    channelSelected: {
	    backgroundColor: theme.palette.darkPurple,
        color: theme.palette.hoveredTextColor,
    },
    globalChannel: {
        display: 'block',
        width: '100%',
        marginBottom: theme.spacing,
        paddingRight: theme.spacing
    },
    globalChannelAnchor: {
        backgroundColor:  theme.palette.darkPurple,
        display: 'block',
        width: '100%',
        textAlign: 'center',
        paddingTop: theme.spacing * 1.5,
        paddingBottom: theme.spacing * 1.5,
        color: theme.palette.channelSelectorTypoLight,
        textDecoration: 'none',
        textTransform: 'uppercase',
        borderRadius: theme.borderRadius / 2,
        [theme.devices.small]: {
            backgroundColor: '#c8c8c8'
        },
        '&.selected': {
            backgroundColor: theme.backgrounds.card,
            color: theme.palette.channelSelectorTypoDark,
            boxShadow: theme.boxShadow,
        }
    },

});

export default injectSheet(styles)(channelsList);



// WEBPACK FOOTER //
// ./src/app/components/channelSelector/ChannelsList.js